/**
 * Hook to listen for achievement unlock events via WebSocket
 * Automatically triggers the achievement celebration when unlocked
 */

import { useSimpleWebSocketEvent } from './useWebSocketEvent'
import { useCelebration } from '../contexts/CelebrationContext'
import audioManager from '../services/audioManager'

export function useAchievementUnlock(isAuthenticated = false) {
  const { celebrateAchievement } = useCelebration()

  useSimpleWebSocketEvent(
    'achievement.unlocked',
    (event) => {
      console.log('🏆 Achievement unlocked event received:', event)

      if (!event.achievement_name) {
        console.warn('Achievement unlocked event missing achievement_name:', event)
        return
      }

      // Extract currency from rewards
      const currencyReward = event.rewards?.currency || 0

      // Build achievement data for celebration
      const achievementData = {
        name: event.achievement_name,
        description: '',
        icon: '⭐',
        rarity: event.rarity || 'common',
        reward: currencyReward
      }

      // Trigger achievement celebration
      celebrateAchievement(achievementData)

      // Play sound
      audioManager.play('achievement')
    },
    isAuthenticated,
    [celebrateAchievement]
  )
}

export default useAchievementUnlock
